<div>
  <div class="top-corner">
    <h3>
      Constructeurs
    </h3>
    <button mat-button class="cta-button" (click)="addNewRow()"><mat-icon>add</mat-icon>Nouveau</button>

  </div>

  <!--
  <form #appointmentForm="ngForm" class="appointment-form">

    <mat-form-field *ngIf="!isReschedule">
      <mat-label>Choisir une date</mat-label>
      <input matInput [matDatepicker]="picker" name="appointmentDate" [(ngModel)]="data.appointmentDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="isReschedule">
      <mat-label>Date alternative</mat-label>
      <input required matInput [matDatepicker]="picker1" name ="rescheduleDate" [(ngModel)]="data.rescheduleDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="!isReschedule">
      <mat-label>Service demandé</mat-label>
      <mat-select name="service" [(ngModel)]="data.serviceType">
        <mat-option *ngFor="let serv of serviceTypes" [value]="serv.code" >{{serv.title}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="!isReschedule">
      <mat-label>Lieu du rendez vous</mat-label>
      <mat-select name="location" [(ngModel)]="data.locationMode">
        <mat-option *ngFor="let loc of locationModes" [value]="loc.code" >{{loc.title}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label >Message</mat-label>
      <textarea matInput type="text"  [readonly]="isReschedule" name ="details" placeholder=""  [(ngModel)]="data.details" ></textarea>
    </mat-form-field>

    <h5>Vous rappeller ?

      <mat-slide-toggle
        class="example-margin"
        name = "needCallback"
        [disabled]="isReschedule"
        [(ngModel)]="data.needCallback"
        >


      </mat-slide-toggle>
    </h5>

    <mat-form-field >
      <mat-label >Message</mat-label>
      <textarea matInput type="text"  [readonly]="false" name ="details" placeholder=""  [(ngModel)]="newManuf.details" ></textarea>
    </mat-form-field>

  </form>
  -->
  <div class="mat-elevation-z8" >

    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>

      </ng-container>
      <!--
      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span >{{element.code}}</span>
          <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.code"
            placeholder="Code" >
          </mat-cell>
        </ng-container>
        -->

        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Code </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [hidden]="(editingItem && element.id===editingItemId)">{{element.code}}</span>
            <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.code"
              placeholder="Code" >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nom </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span [hidden]="(editingItem && element.id===editingItemId)">{{element.name}}</span>
              <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.name"
                placeholder="Nom" >
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="parts_only">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Pièces uniquement ? </mat-header-cell>
              <mat-cell *matCellDef="let element">

                @if (!(editingItem && element.id===editingItemId)) {
                  <mat-slide-toggle
                    name = "p"
                    [disabled]="!(editingItem && element.id===editingItemId)"
                    [(ngModel)]="element.partsOnly">
                  </mat-slide-toggle>
                }
                @if ((editingItem && element.id===editingItemId)) {
                  <mat-slide-toggle
                    name = "pe"
                    [(ngModel)]="editedItem.partsOnly">
                  </mat-slide-toggle>
                }
                <!-- <input [hidden]="!(editingItem && element.id===editingItemId)" matInput [(ngModel)]="editedItem.partsOnly"
                placeholder="Nom" > -->
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="lastUpdated">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Modifié le </mat-header-cell>
              <mat-cell *matCellDef="let element" > {{dateTimeFormat(element.lastUpdated)}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Actions </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-button class="simple-button" (click)="editItem(element.id)" [hidden]="(editingItem && element.id===editingItemId)"><mat-icon>edit</mat-icon></button>
                <button mat-button class="simple-button" (click)="SaveItem(element.id)" [hidden]="!(editingItem && element.id===editingItemId)" [disabled]="!editedItemIsValid()">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-button class="simple-button" (click)="deleteItem(element.id)"><mat-icon>{{editingItem && element.id===editingItemId ? 'undo' : 'delete'}}</mat-icon>{{editingItem &&  element.id===editingItemId ? '' : ''}}</button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>

          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>

      </div>
